import {constants, typographyStyles} from '@newsela/angelou';
import {css} from 'emotion';

const {ui} = constants.colors;

export const licenseContainer = css({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '5px 0',
});

export const productListContainer = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  cursor: 'default',
  rowGap: 12,
  margin: '12px 0',
});

export const productList = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  padding: '0 24px',
  margin: 0,
  ul: {
    width: '90%',
    listStyle: 'disc',
    borderRadius: '8px',
    paddingInlineStart: 0,
    marginLeft: 5,
    li: {
      listStyleType: 'disc',
      paddingLeft: 6,
    },
  }
});

export const sectionLabel = css({
  ...typographyStyles.textXSObj,
  ...typographyStyles.textCapsObj,
  fontWeight: 'normal',
  margin: 0,
});

export const trialDays = css({
  alignSelf: 'flex-end',
  fontSize: '12px',
  paddingRight: '16px',
  color: ui.red[700],
});

export const listItemStyle = css({
  ...typographyStyles.textMObj,
});
